// extracted by mini-css-extract-plugin
export default {"container":"PaypalInfo_container__46xdc","text":"PaypalInfo_text__PQSrR"};